import { batchTypesConstatns } from "../../../utils/constants";
import { Utm } from "../../../models/utms/UtmModel";
import CodeParamsStore from "../../../stores/domain/parameters/CodeParamsStore";
import ScanParamsStore from "../../../stores/domain/parameters/ScanParamsStore";
import CountParamsStore from "../../../stores/domain/parameters/CountParamsStore";
import PremiumParamsStore from "../../../stores/domain/parameters/PremiumParamsStore";
import CustomParamsStore from "../../../stores/domain/parameters/CustomParamsStore";
import GS1ParamsStore from "../../../stores/domain/parameters/GS1ParamStore";

export function addUtmToCode(state){
    if (state.utmModalState.noUtmOpen || !state.utmModalState.utm.doesUtmHaveValue()) {
        state.utm = Utm.create({uuid: "noUtm"})
        if(state.utmModalState.noUtmOpen){
            state.utmModalState.reset(false)
        } else {
            state.utmModalState.reset(true)
        }
        if(state.batchType === batchTypesConstatns.EDIT) {
            state.utmModalState.isRemovedUTM = true
        }
    } else {
        state.utm = state.utmModalState.utm.grabUtmForCode()
        state.utmModalState.isRemovedUTM = false
    }
}

export async function initUtmParameterSelectState(rootStore){
    const utmParameterSelectStore = rootStore.rootUiStore.utmParameterSelectState;
    utmParameterSelectStore.setCodeParamsTypeSelectState(rootStore.rootUiStore.codeParamsStore);
    utmParameterSelectStore.setGS1ParamsTypeSelectState(rootStore.rootUiStore.gs1ParamsStore);
    utmParameterSelectStore.setUtmExtedDataSelectState(rootStore.rootUiStore.extendedDataSelectStore);
    return utmParameterSelectStore;
}